import {
  hasMatchingCategories,
  hasMatchingGenders,
  hasMatchingProduct,
  hasMatchingProductTag,
} from './matcher-utils';

export const QUOTE_FILTER_TYPES = [
  { name: 'genders', matcher: hasMatchingGenders },
  { name: 'categories', matcher: hasMatchingCategories },
  { name: 'products', matcher: hasMatchingProduct },
  { name: 'productTags', matcher: hasMatchingProductTag },
];

export const isLineFilteredOut = (line, selectedFilters) =>
  QUOTE_FILTER_TYPES.some(
    ({ name, matcher }) => !matcher(line, selectedFilters[name]),
  );

export function getAvailableFilterValues(quoteLinesById) {
  const categories = new Set();
  const genders = new Set();
  const productIds = new Set();
  const productTags = new Set();

  Object.values(quoteLinesById).forEach(line => {
    if (line.genders) line.genders.map(g => genders.add(g));
    if (line.productTag) productTags.add(line.productTag);
    if (line.productId) productIds.add(line.productId);
    if (line.categories) line.categories.map(g => categories.add(g));
  });

  return {
    categories: Array.from(categories),
    genders: Array.from(genders),
    productIds: Array.from(productIds),
    productTags: Array.from(productTags),
  };
}

export function getCategoryOptions(availableCategories, allCategories) {
  return allCategories
    .map(group => ({
      ...group,
      options: group.options.filter(({ value }) =>
        availableCategories.includes(value),
      ),
    }))
    .filter(group => group.options.length);
}

export function getProductOptions(availableProductIds, allProducts) {
  return availableProductIds.map(id => {
    const product = allProducts.find(p => p.id === id);
    const label = `${product.name} - ${product.business}, ${product.productGroup}`;
    return {
      label,
      value: product.id,
    };
  });
}
